module.exports = __webpack_public_path__ + "img/agenda.5a8ddf49.svg";